import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import * as fromKeywordsState from "./reducer";
import { KeywordsEffects } from "./effects";
import { InsightsApiService } from "@app/services/insights-api.service";
import { InsightsDashboardPageComponent } from "@app/components/pages/insights-dashboard/insights-dashboard-page.component";
/**
 * Insights keyword module
 *
 * @export KeywordsModule
 * @class KeywordsModule
 */
@NgModule({
    declarations: [InsightsDashboardPageComponent],
    imports: [
            CommonModule,
            StoreModule.forFeature(
                fromKeywordsState.insightsKeywordStateFeatureKey,
                fromKeywordsState.insightsKeywordsReducer
            ),
            EffectsModule.forFeature([KeywordsEffects])
        ]
    })

export class KeywordsModule {}
